module.exports = __webpack_public_path__ + "img/timer.8a32d804.svg";